// TablePaginationFooter.js
import React from "react";
import { PAGE_SIZE_OPTIONS } from "./Functions";
import './TableFooter.css'
import Select from "react-select";
export default function TablePaginationFooter({
  total,
  page,
  pageSize,
  setPage,
  setPageSize,
  canPrev,
  canNext,
  className = ""
}) {
  const from = total ? page * pageSize + 1 : 0;
  const to = Math.min((page + 1) * pageSize, total);

  const ClearIndicatorStyles = (base, state) => ({
  ...base,
  cursor: "pointer",
  color: state.isFocused ? "#525252" : "#7e7e7e",
});

const ClearIndicator = (props) => {
  const {
  getStyles,
  innerProps: { ref, ...restInnerProps },
  } = props;
  return (
    <div
        {...restInnerProps}
        ref={ref}
        style={getStyles("clearIndicator", props)}
    >
        <div style={{ padding: "0px 5px" }}>Clear</div>
    </div>
  );
};
  return (
    <div className={`table-pagination mb-2 ${className}`}>
      <div className="table-pagination-left">
        <label className="page-size-label" htmlFor="pageSize">
          Rows per page:
        </label>
        <select
          id="pageSize"
          className="page-size-select"
          value={pageSize}
          onChange={(e) => setPageSize(Number(e.target.value))}
        >
          {PAGE_SIZE_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        <span className="page-status">
          {from}-{to} of {total}
        </span>
      </div>

      <div className="table-pagination-right">
        <button
          type="button"
          className="pager-btn pager-prev"
          onClick={() => canPrev && setPage(page - 1)}
          disabled={!canPrev}
          aria-label="Previous page"
          title="Previous"
        >
          ‹ Prev
        </button>
        <button
          type="button"
          className="pager-btn pager-next"
          onClick={() => canNext && setPage(page + 1)}
          disabled={!canNext}
          aria-label="Next page"
          title="Next"
        >
          Next ›
        </button>
      </div>
    </div>
  );
}
